import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import DisplaySettings from "../components/settings/displaySettings/displaySettings";
import StoreSetting from "../components/settings/storeSetting/storeSetting";
import ReceiptsSettings from "../components/settings/receiptsSettings";
import SettingScreen from "../components/settings/settingScreen";
import LocationStack from "./locationStack";
import ZoneStack from "./zoneStack";
import { forSlideFromLeftAnimation } from "../shared/hooks/funcions";
import OrderSettings from "../components/settings/orderSettings";
import ProductSettings from "../components/settings/productSettings";

// custom imports
/* 
  Functional component to hold all the pages in a stack navigator
 */
const SettingStack = () => {
    // Variable to handle appStack
    const AppStack = createStackNavigator();

    return (
        <AppStack.Navigator
            initialRouteName={"SettingScreen"}
            screenOptions={{ headerShown: false, cardStyleInterpolator: forSlideFromLeftAnimation }}>
            <AppStack.Screen name="SettingScreen" component={SettingScreen} />
            <AppStack.Screen name="DisplaySettings" component={DisplaySettings} />
            <AppStack.Screen name="StoreSetting" component={StoreSetting} />
            <AppStack.Screen name="LocationStack" component={LocationStack} />
            <AppStack.Screen name="ReceiptsSettings" component={ReceiptsSettings} />
            <AppStack.Screen name="ZoneStack" component={ZoneStack} />
            <AppStack.Screen name="OrderSettings" component={OrderSettings} />
            <AppStack.Screen name="ProductSettings" component={ProductSettings} />

        </AppStack.Navigator>
    );
};

export default SettingStack;